var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("选择颜色"),
      visible: _vm.dialogVisible,
      width: 600
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.colorList, function (item, index) {
    return _c("div", {
      key: index,
      class: item.key == _vm.color ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.colorFun(item);
        }
      }
    }, [_c("div", {
      style: "background:" + item.key
    })]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };